export default "__VITE_ASSET__uFId83jSdgV9I4oCl8vk1A__"